(ns app.domain.application.guards.periodic-inspection
  (:require [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]))

(def all-inspection-workspaces-complete-or-closed?
  {:name    :process.guard/all-inspection-workspaces-complete-or-closed?
   :summary "Given a periodic parent phase-entity, check all the linked inspection workspaces are complete or closed."
   :type    :guard
   :handler (fn [{{:keys [target]} :request}]
              (->> target
                   :entity/parent ; parent workspace
                   :workspace/_parent-workspace
                   (map workspace-model/workspace-execution)
                   (every? (du/in-state-fn :execution.state/complete
                                           :execution.state/closed))))})


(def guards
  [all-inspection-workspaces-complete-or-closed?])
